<!-- <div> -->
<!-- <p class="timeFilters">
      <label>Time Frame:</label>
      <mat-button-toggle-group (change)="timeFrameSelected($event);" [(ngModel)]="graphFilterData['TimePeriod']" appearance="legacy" name="timeFrame" aria-label="Time Frame">
          <mat-button-toggle value="2">Last 24h</mat-button-toggle>
          <mat-button-toggle value="3">Last 7 Days</mat-button-toggle>
          <mat-button-toggle value="4">Last Month</mat-button-toggle>
          <mat-button-toggle value="0">Custom</mat-button-toggle>
      </mat-button-toggle-group>
  </p>

  <div [hidden]="!(graphFilterData['TimePeriod'] == '0')" class="customDates">
      <div>
          <tools-date-time
              [label]="'Start'"
              [Morning]="true"
              (notify)="updateStart($event)">
          </tools-date-time>
      </div>

      <div>
          <tools-date-time
              [label]="'End'"
              (notify)="updateEnd($event)">
          </tools-date-time>
      </div>
  </div>

  <div class="centeredinput">
      <tools-searchable-combobox #times
          class="fieldSelect"
          *ngIf="TimeFilters && TimeFilters.length > 0"
          [isRequired]="true"
          [multipleAllowed]="false"
          [comboboxHeading]="'Select a time filter'"
          [comboboxPlaceholderName]="'Find a time filter'"
          [unFilteredOptions]="TimeFilters"
          [preSelected]="[selectedInterval]"
          (notify)='updateSelectedTimeFilter($event)'>
      </tools-searchable-combobox>
  </div> -->
<!-- <div>
      <button class="pull-right" mat-raised-button (click)="refreshGraph();"><i class="material-icons">refresh</i> Refresh Graph</button>
  </div> -->
<huge-row class="graph-top-buttons">
	<div class="pull-left">
		<label>Time Frame:</label>
		<mat-button-toggle-group
			(change)="timeFrameSelected()"
			[(ngModel)]="graphFilterData['TimePeriod']"
			appearance="legacy"
			name="timeFrame"
			aria-label="Time Frame">
			<mat-button-toggle value="2">Last 24h</mat-button-toggle>
			<mat-button-toggle value="3">Last 7 Days</mat-button-toggle>
			<mat-button-toggle value="4">Last Month</mat-button-toggle>
			<mat-button-toggle value="0">Custom</mat-button-toggle>
		</mat-button-toggle-group>
	</div>
	<button
		mat-raised-button
		class="pull-right"
		(click)="refreshGraph()"
		><i class="material-icons">refresh</i> Refresh Graph</button
	>
</huge-row>
<huge-row class="graph-date-time">
	<div
		[hidden]="!(graphFilterData['TimePeriod'] == '0')"
		class="customDates">
		<div>
			<app-date-time
				[label]="'Start'"
				[Morning]="true"
				(notify)="updateStart($event)">
			</app-date-time>
		</div>

		<div>
			<app-date-time
				[label]="'End'"
				(notify)="updateEnd($event)">
			</app-date-time>
		</div>
		<div>
			@if (TimeFilters && TimeFilters.length > 0) {
<app-searchable-combobox
				#times
				class="fieldSelect"
			
				[isRequired]="true"
				[multipleAllowed]="false"
				[comboboxHeading]="'Select a time filter'"
				[comboboxPlaceholderName]="'Find a time filter'"
				[unFilteredOptions]="TimeFilters"
				[preSelected]="[selectedInterval]"
				(notify)="updateSelectedTimeFilter($event)">
			</app-searchable-combobox>
}
		</div>
	</div>
</huge-row>

@if (loading && !graphLoaded) {
<div
	class="mauto text-center"
>
	<br />
	<br />
	<br />
	<br />
	<mat-spinner
		class="spinner mauto"
		name="crescent"></mat-spinner>
	<br />
	<br />
</div>
}

@if (!loading && graphLoaded) {
<div
	class="apx-graph"
>
	<div id="chart">
		<apx-chart
			[series]="chartOptions.series"
			[chart]="chartOptions.chart"
			[xaxis]="chartOptions.xaxis"
			[stroke]="chartOptions.stroke"
			[colors]="chartOptions.colors"
			[dataLabels]="chartOptions.dataLabels"
			[legend]="chartOptions.legend"
			[markers]="chartOptions.markers"
			[grid]="chartOptions.grid"
			[yaxis]="chartOptions.yaxis"
			[title]="chartOptions.title"></apx-chart>
	</div>
</div>
}
<!-- <mat-spinner class="mainSpinner" [diameter]="40" *ngIf="loading"></mat-spinner> -->
<!-- </div> -->
